<template lang="pug">
.generic-wrapper
  .container
    BackButton(name="SettingsOverview")
    h1.title Ausstattungstypen
    .sub-headline Hier können Sie alle möglichen Ausstattungstypen pflegen.

    .button-flex.margin-top
      .button-wrapper  
        b-button(type="is-light" icon-left="plus" @click="newFeatureTag()") Neuen Ausstattungstyp anlegen
        b-button(type="is-light" icon-left="shuffle" @click="$router.push({name: 'SettingsFeatureTagsAdminSort'})") Sortierung Buchungskalender
        b-button(type="is-light" icon-left="shuffle" @click="$router.push({name: 'SettingsFeatureTagsWebsiteSort'})") Sortierung Kundenwebseite

    .margin-top
      .card
        .main
          b-table(
          :data="featureTags",
          default-sort-direction="asc",
          default-sort="name",
          hoverable)
            b-table-column(field="name", label="Name", sortable, v-slot="props")
              | {{ props.row.name }}
            b-table-column(field="internalDescription", label="Interne Beschreibung", v-slot="props")
              .is-small {{ props.row.internalDescription }}
            b-table-column(field="externalDescription", label="Kunden Beschreibung", v-slot="props")
              .is-small {{ props.row.externalDescription }}
            b-table-column(field="showAdmin", label="Admin Filter", v-slot="props")
              b-icon(v-if="props.row.showAdmin"
                    icon="check"
                    type="is-success")
              b-icon(v-else
                    icon="close")
            b-table-column(field="showCustomer", label="Kunden Filter", v-slot="props")
              b-icon(v-if="props.row.showCustomer"
                    icon="check"
                    type="is-success")
              b-icon(v-else
                    icon="close")
            b-table-column(
              label="Objekt-#",
              v-slot="props"
              centered)
              | {{ props.row.rentObjectFeatureTags.length }}x
            b-table-column(v-slot="props" width="120")
              div
                b-tooltip(label='Bearbeiten' type='is-secondary' position='is-bottom' :delay="1250")
                  b-button(icon-right="pencil", type="is-secondary" @click="openModal(props.row)")
                .spacer.sm.inline
                b-tooltip(label='Dauerhaft löschen' type='is-danger' position='is-bottom' :delay="1250" v-if="props.row.rentObjectFeatureTags.length === 0")
                  b-button(icon-right="close", type="is-danger" @click="deleteLabel(props.row)")
                b-tooltip(label='Wird in Objekten verwendet' type='is-danger' position='is-bottom' v-else)
                  b-button(icon-right="close", type="is-danger" disabled)

      b-modal(v-model='isModalActive' has-modal-card='' trap-focus='' :destroy-on-hide='false' aria-role='dialog' aria-modal='')
        template(#default='props')
          .card.form.w320.margin-top
            .top
              h2.title.is-6(v-if="formData.id") Ausstattungstyp aktualisieren
              h2.title.is-6(v-else) Neuer Ausstattungstyp
              ValidationObserver(v-slot="{ handleSubmit }", ref="form")
                ValidationProvider(name="Neuer Ausstattungstyp" rules="required|min:2" v-slot="{ errors, valid }")
                  b-field(label="Neuer Ausstattungstyp" label-position="on-border"
                  :type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors")
                    b-input(v-model="formData.name")
                ValidationProvider(name="Internal Beschreibung" rules="" v-slot="{ errors, valid }")
                    b-field(label="Internal Beschreibung" label-position="on-border"
                    :type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors")
                      b-input(v-model="formData.internalDescription" type="textarea" maxlength="255")
                ValidationProvider(name="Kunden Beschreibung" rules="" v-slot="{ errors, valid }")
                    b-field(label="Kunden Beschreibung" label-position="on-border"
                    :type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors")
                      b-input(v-model="formData.externalDescription" type="textarea" maxlength="255")
                b-field
                  b-switch(type="is-success" v-model="formData.showAdmin") Filter im Buchungskalender
                b-field
                  b-switch(type="is-success" v-model="formData.showCustomer") Filter auf der Gast Webseite

                .button-wrapper.margin-top.right
                  b-button(
                    type="is-light",
                    @click="isModalActive = false"
                  ) Abbrechen
                  b-button(
                    v-if="formData.id"
                    type="is-primary",
                    @click="handleSubmit(createFeatureTag)"
                  ) Aktualisieren
                  b-button(
                    v-else
                    type="is-primary",
                    @click="handleSubmit(createFeatureTag)"
                  ) Speichern
</template>

<script>
// import { DateTime } from "luxon";

export default {
  data() {
    return {
      isModalActive: false,
      formData: {
        name: null,
        internalDescription: null,
        externalDescription: null,
        showAdmin: false,
        showCustomer: false
      },
    };
  },
  computed: {
    featureTags() {
      return this.$store.state.featureTags.all;
    }
  },
  methods: {
    newFeatureTag() {
      this.formData = {
        name: null,
        internalDescription: "",
        externalDescription: "",
        showAdmin: false,
        showCustomer: false
      };
      this.isModalActive = true;
    },
    openModal(p) {
      this.formData = {...this.formData, ...p};
      this.isModalActive = true;
    },
    async createFeatureTag() {
      await this.$store.dispatch("featureTags/create", this.formData);

      // Here we are resetting all fields
      this.formData.name = null;
      this.formData.description = null;
      this.formData.showAdmin = false;
      this.formData.showCustomer = false;

      this.$refs.form.reset();
      this.isModalActive = false;
    },
    async updateFeatureTag(e, idx, type) {
      const ft = JSON.parse(JSON.stringify(this.featureTags[idx]));
      if(type === "admin") {
        ft.showAdmin = e;
      } else {
        ft.showCustomer = e;
      }
      await this.$store.dispatch("featureTags/update", ft);
    },
    deleteLabel(label) {
      this.$buefy.dialog.confirm({
        title: "Ausstattungstyp löschen",
        message: `Sind Sie sicher, dass Sie diesen Ausstattungstyp <b>${label.name}</b> löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.`,
        confirmText: "Jetzt löschen",
        cancelText: "Abbrechen",
        type: "is-danger",
        hasIcon: true,
        onConfirm: async () => {
          try {
            await this.$store.dispatch("featureTags/delete", {
              id: label.id
            });
            this.$buefy.toast.open("Ausstattungstyp gelöscht!");
          } catch (e) {
            this.$store.dispatch(
              "common/showError",
              "Ausstattungstyp konnte nicht gelöscht werden."
            );
          }
        }
      });
    }
  },
  async mounted() {
    await this.$store.dispatch("featureTags/findAll");
  }
};
</script>

<style lang="scss" scoped>
.is-small {
  font-size: 0.8rem;
}
</style>